// assets/smart-quick-add.js

if (!customElements.get('smart-quick-add')) {
  customElements.define('smart-quick-add', class extends HTMLElement {
    constructor() {
      super();
      // 初始化绑定内部元素
      this.actionArea = this.querySelector('.js-qa-action');
      this.submitBtn = this.querySelector('.js-qa-submit-btn');
      this.variantInput = this.querySelector('.js-variant-id-input');
      this.optionGroups = this.querySelectorAll('.qa-option-group');
      
      // 存储重置定时器，防止鼠标快速反复滑入滑出导致冲突
      this.resetTimer = null;
      
      // 解析变体数据
      try {
        const dataNode = this.querySelector('.js-variant-data');
        this.variantData = dataNode ? JSON.parse(dataNode.textContent) : [];
      } catch (e) {
        console.error('Failed to parse variant data', e);
        this.variantData = [];
      }

      this.bindEvents();
    }

    bindEvents() {
      // 1. 绑定属性选择事件
      const propertyBtns = this.querySelectorAll('.js-qa-property-btn');
      propertyBtns.forEach(btn => {
        btn.addEventListener('click', (e) => this.handleOptionSelect(e.currentTarget));
      });

      // 2. 绑定提交购物车事件
      if (this.submitBtn) {
        this.submitBtn.addEventListener('click', (e) => this.handleAddToCart(e));
      }

      // 3. 核心优化：监听鼠标移出/移入商品卡片事件
      const cardWrapper = this.closest('.card-wrapper');
      if (cardWrapper) {
        // 鼠标移出：延迟 400ms 重置面板
        cardWrapper.addEventListener('mouseleave', () => {
          // 【核心修复】：如果是移动端(<=749px)或弹窗已打开状态，直接拦截，防止误触导致面板重置和购买按钮消失
          if (window.innerWidth <= 749 || document.body.classList.contains('qa-drawer-open')) return;

          this.resetTimer = setTimeout(() => {
            this.resetPanel();
          }, 400);
        });

        // 鼠标移入：立刻取消重置，保留当前状态
        cardWrapper.addEventListener('mouseenter', () => {
          // 【核心修复】：移动端不处理此逻辑
          if (window.innerWidth <= 749 || document.body.classList.contains('qa-drawer-open')) return;

          if (this.resetTimer) {
            clearTimeout(this.resetTimer);
          }
        });
      }
    }

    handleOptionSelect(clickedBtn) {
      const group = clickedBtn.closest('.qa-option-group');
      
      // 同组按钮高亮切换
      group.querySelectorAll('.js-qa-property-btn').forEach(b => b.classList.remove('is-active'));
      clickedBtn.classList.add('is-active');

      // 检查并匹配商品变体
      this.checkAndMatchVariant();
    }

    checkAndMatchVariant() {
      let selectedOptions = [];
      let allSelected = true;

      // 收集所有已选的值
      this.optionGroups.forEach(group => {
        const activeBtn = group.querySelector('.is-active');
        if (activeBtn) {
          selectedOptions.push(activeBtn.dataset.value);
        } else {
          allSelected = false;
        }
      });

      // 只有所有属性组都选择了，才匹配变体ID并显示购买按钮
      if (allSelected) {
        const matchedVariant = this.variantData.find(v => {
          return v.options.every((opt, idx) => opt === selectedOptions[idx]);
        });

        if (matchedVariant) {
          this.variantInput.value = matchedVariant.id;
          
          // 显示购买按钮
          if (this.actionArea) this.actionArea.classList.add('is-visible');

          if (!matchedVariant.available) {
            this.submitBtn.innerText = 'SOLD OUT';
            this.submitBtn.disabled = true;
          } else {
            this.submitBtn.innerText = 'ADD TO BASKET';
            this.submitBtn.disabled = false;
          }
        }
      }
    }

    handleAddToCart(event) {
      event.preventDefault();
      if (this.submitBtn.disabled) return;

      const variantId = this.variantInput.value;
      this.submitBtn.innerText = 'ADDING...';
      this.submitBtn.disabled = true;

      const rootUrl = window.Shopify?.routes?.root || '/';
      const sectionsToUpdate = ['cart-icon-bubble', 'cart-drawer', 'cart-notification'];

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript' 
        },
        body: JSON.stringify({ 
          items: [{ id: parseInt(variantId), quantity: 1 }],
          sections: sectionsToUpdate.join(','),
          sections_url: window.location.pathname
        })
      })
      .then(res => {
        if (!res.ok) throw new Error('Network error');
        return res.json();
      })
      .then(parsedState => {
        this.submitBtn.innerText = 'SUCCESS ✓';
        
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && parsedState.sections['cart-icon-bubble']) {
          bubble.innerHTML = this.getSectionInnerHTML(parsedState.sections['cart-icon-bubble'], '#cart-icon-bubble');
        }

        const cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');
        
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(parsedState);

          if (typeof cartDrawer.open === 'function') {
             cartDrawer.open();
          }
        } else if (cartNotification && typeof cartNotification.renderContents === 'function') {
          cartNotification.renderContents(parsedState);
        }

        // 加购完成后，稍微延迟后自动隐藏并清空选项 (若在移动端会自动调用 closeDrawer 关闭并重置)
        setTimeout(() => {
          if (window.innerWidth <= 749) {
            // 移动端加购成功后直接触发全局关闭函数
            if (typeof window.triggerCloseDrawer === 'function') window.triggerCloseDrawer();
          } else {
            this.resetPanel();
          }
        }, 800); 
      })
      .catch(err => {
        console.error('AJAX Cart Error:', err);
        this.submitBtn.innerText = 'ERROR';
        setTimeout(() => {
          this.submitBtn.innerText = 'ADD TO BASKET';
          this.submitBtn.disabled = false;
        }, 2000);
      });
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML || html;
    }

    resetPanel() {
      if(this.submitBtn) {
        this.submitBtn.innerText = 'ADD TO BASKET';
        this.submitBtn.disabled = false;
      }
      
      if (this.actionArea) {
        this.actionArea.classList.remove('is-visible');
      }
      
      this.querySelectorAll('.js-qa-property-btn').forEach(b => {
        b.classList.remove('is-active');
      });
    }
  });
}

(function() {
  if (window.MobileDrawerTeleporterInit) return;
  window.MobileDrawerTeleporterInit = true;

  let overlay = document.createElement('div');
  overlay.className = 'mobile-qa-overlay';
  document.body.appendChild(overlay);

  let activePanel = null;
  let originalParent = null;
  let originalNextSibling = null;

  function closeDrawer() {
    if (activePanel) {
      activePanel.classList.remove('is-active-drawer');
      
      // 【核心修复】：在面板送回原位前，调用 resetPanel 彻底清理选中状态，防止下次打开时残留
      if (typeof activePanel.resetPanel === 'function') {
        activePanel.resetPanel();
      }

      if (originalParent) {
        originalParent.insertBefore(activePanel, originalNextSibling);
      }
      activePanel = null;
    }
    document.body.classList.remove('qa-drawer-open');
    overlay.style.display = 'none';
  }

  // 暴露给外部调用（用于加购成功后自动关闭抽屉）
  window.triggerCloseDrawer = closeDrawer;

  overlay.addEventListener('click', closeDrawer);

  document.body.addEventListener('click', function(e) {
    if (window.innerWidth > 749) return; 

    if (e.target.closest('.js-qa-close-btn')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    if (e.target.closest('.qa-more-details')) return;

    const card = e.target.closest('.js-mobile-card');
    if (card) {
      if (e.target.closest('smart-quick-add')) return;

      const link = e.target.closest('a');
      if (link) e.preventDefault();
      
      e.preventDefault();
      e.stopPropagation();

      const panelToOpen = card.querySelector('smart-quick-add');
      if (panelToOpen) {
        closeDrawer();

        originalParent = panelToOpen.parentNode;
        originalNextSibling = panelToOpen.nextSibling;
        activePanel = panelToOpen;

        document.body.appendChild(panelToOpen);

        requestAnimationFrame(() => {
          panelToOpen.classList.add('is-active-drawer');
        });

        document.body.classList.add('qa-drawer-open');
        overlay.style.display = 'block';
      }
    }
  }, true); 
})();